
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[[...routes]]",
      function () {
        return require("private-next-pages/search/[[...routes]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[[...routes]]"])
      });
    }
  